var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18.001,
    viewBox: "0 0 18 18.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-instagram",
    "data-name": "Icon awesome-instagram",
    d: "M9,6.623a4.615,4.615,0,1,0,4.614,4.615A4.607,4.607,0,0,0,9,6.623Zm0,7.616a3,3,0,1,1,3-3,3.006,3.006,0,0,1-3,3Zm5.879-7.8A1.076,1.076,0,1,1,13.8,5.358,1.074,1.074,0,0,1,14.876,6.434Zm3.056,1.093a5.328,5.328,0,0,0-1.454-3.772A5.36,5.36,0,0,0,12.707,2.3c-1.486-.084-5.939-.084-7.425,0a5.352,5.352,0,0,0-3.771,1.45A5.346,5.346,0,0,0,.058,7.523c-.084,1.486-.084,5.941,0,7.427a5.328,5.328,0,0,0,1.454,3.772,5.367,5.367,0,0,0,3.771,1.454c1.486.084,5.939.084,7.425,0a5.325,5.325,0,0,0,3.771-1.454,5.363,5.363,0,0,0,1.454-3.772c.084-1.486.084-5.937,0-7.423Zm-1.919,9.018A3.037,3.037,0,0,1,14.3,18.256c-1.185.47-4,.362-5.3.362s-4.124.1-5.3-.362a3.037,3.037,0,0,1-1.711-1.711c-.47-1.185-.361-4-.361-5.306s-.1-4.125.361-5.306A3.037,3.037,0,0,1,3.692,4.221c1.185-.47,4-.362,5.3-.362s4.124-.1,5.3.362a3.037,3.037,0,0,1,1.711,1.711c.47,1.185.361,4,.361,5.306S16.482,15.364,16.012,16.545Z",
    transform: "translate(0.005 -2.238)",
    fill: "#221f20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.092e6d07202b4a4c4979a760083fa291.svg";
export { ForwardRef as ReactComponent };